interface ErrorAlertProps {
  error: string | null;
  onDismiss: () => void;
  submitButtonText?: string;
}

/**
 * Error alert component for RecorderPanel.
 * Shows error messages with special handling for rate limit errors.
 */
export function ErrorAlert({ error, onDismiss, submitButtonText = "Create Post" }: ErrorAlertProps) {
  if (!error) {
    return null;
  }

  const isRateLimitError = error.includes("Please wait a moment");

  return (
    <div className="rounded-2xl border border-rose-400/20 bg-rose-500/5 p-3 text-sm text-rose-200/80">
      {error}
      {isRateLimitError && (
        <div className="mt-2 text-rose-200/60 text-xs">
          Wait a few seconds, then click "{submitButtonText}" again to retry.
        </div>
      )}
      <button
        onClick={onDismiss}
        className="ml-2 underline"
      >
        Dismiss
      </button>
    </div>
  );
}
